<p>receptionlist-client-view-page works!</p>
